import { Drawer, styled } from "@mui/material";

export const StyledDrawer = styled(Drawer)<{ expanded?: boolean }>((props) => ({
  '.MuiDrawer-paper' : {
    borderTopLeftRadius: '10px',
    marginTop: '10px',
    width: `${props?.expanded ? '100%' : ''}`,
  }
}));
